import React from 'react'
import Grid from '@mui/material/Grid'
import SimpleTextField from '../../../../../components/Forms/SimpleTextField'

const PEFR = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <SimpleTextField
      label="Peak Flow"
      value={value}
      type="number"
      onChange={onChange}
      InputProps={{
        endAdornment: 'l/min',
        inputProps: { min: 1, max: 1000, step: 'any' },
      }}
    />
  </Grid>
)

export default PEFR
